import {z} from '@hono/zod-openapi';

import {identifiers} from './identifiers';
import {isWithinMaxReportSpan} from './isWithinMaxReportSpan';
import {MAX_REPORT_SPAN_DAYS} from './MAX_REPORT_SPAN_DAYS';

export const DeadStockQuerySchema = z
  .object({
    from: z.string().date().openapi({example: '2026-01-01'}),
    to: z.string().date().openapi({example: '2026-09-08'}),
    branch: identifiers,
    warehouse: identifiers,
    manufacturer: identifiers,
  })
  .refine((value) => value.from <= value.to, {message: 'Invalid period', path: ['to']})
  .refine((value) => isWithinMaxReportSpan(value.from, value.to), {
    message: `The period must not span more than ${MAX_REPORT_SPAN_DAYS} days`,
    path: ['to'],
  })
  .openapi('DeadStockQuery');

export type DeadStockQuery = z.infer<typeof DeadStockQuerySchema>;
